import { useEffect, useState } from 'react';
import { getMode, onModeChange, reprobe, type Mode } from '../api/client';
import { Icon } from './Icon';

/**
 * 모의 데이터 모드 배너 — 기동 시 서버 확인(/health)이 실패했을 때만 뜬다.
 *
 * 검토자가 "지금 보는 것이 실데이터인가"를 오해하면 안 된다.
 * 특히 모의 임베딩으로는 검색 품질(nDCG)을 평가할 수 없다.
 * 실행 중 개별 요청이 실패하면 모의로 바꾸지 않고 그 화면이 오류 · 「다시 시도」를 그린다 (리뷰 6회차 M20).
 * 「다시 연결」은 서버가 뒤늦게 떴는지 확인하고, 떠 있으면 화면을 새로 연다 — 모의와 실데이터가 섞이지 않게.
 */
export default function ModeBanner() {
  const [mode, setMode] = useState<Mode>(getMode());
  const [busy, setBusy] = useState(false);
  const [still, setStill] = useState(false);
  useEffect(() => onModeChange(setMode), []);

  if (mode !== 'mock') return null;

  const retry = async () => {
    setBusy(true);
    setStill(false);
    const live = await reprobe();
    if (live) { window.location.reload(); return; }
    setBusy(false);
    setStill(true);
  };

  return (
    <div className="mode-banner" role="status">
      <div className="page mode-banner-in">
        <Icon name="warning" size={16} />
        <p>
          <b>모의 데이터 모드</b>
          서버에 연결되지 않아 내장 샘플 16건으로 동작 중입니다.
          화면 구성과 흐름 검토용이며, <b>검색 품질 평가에는 사용할 수 없습니다.</b>
          {still && <> 아직 서버에 연결되지 않습니다.</>}
        </p>
        <button type="button" className="btn sm" disabled={busy} onClick={() => void retry()}>
          <Icon name={busy ? 'loader' : 'refresh'} size={16} className={busy ? 'spin' : undefined} />
          {busy ? '확인 중…' : '다시 연결'}
        </button>
      </div>
    </div>
  );
}
